/** The sign-in / sign-up page: the brand background with the mascot beside the form. */
import type { ReactNode } from 'react';
import { Mascot } from './Brand';

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="om-auth">
      <div className="om-auth-hero">
        <Mascot width={400} />
      </div>
      <div className="om-auth-panel">{children}</div>
    </div>
  );
}
